import { EventEmitter, Injectable, Output } from '@angular/core';

interface notificationInterface {
	notificationMessage: string;
	functionOnMessage: Function;
	clearNotificationTimeOut: number;
	timerMS: number;
	toLeave: boolean;
	uniqueId?: string;
}

interface notificationOptionsInterface {
	url?: string;
	uniqueId?: string;
	timerMS?: number;
}

@Injectable({
	providedIn: 'root',
})
export class NotificationService {
	constructor() {}

	private _leaveTimer = 400;

	public notificationLine: notificationInterface[] = [];
	public onScreenNotificationLine: notificationInterface[] = [];

	public setNotificationMessage(notificationMessage: string, options?: notificationOptionsInterface): void {
		const findNotification = this.notificationLine.find(
			(notification) => notification.uniqueId !== undefined && notification.uniqueId === options?.uniqueId
		);
		if (notificationMessage === '' || (options?.uniqueId && findNotification)) return;

		const newNotification: notificationInterface = {
			notificationMessage: notificationMessage,
			functionOnMessage: undefined,
			clearNotificationTimeOut: undefined,
			toLeave: false,
			timerMS: options?.timerMS ?? 10_000,
			uniqueId: options?.uniqueId ?? Math.random().toString(36).slice(2),
		};

		this.notificationLine.push(newNotification);
		this.onScreenNotificationLine.push(newNotification);
		if (newNotification.timerMS <= 0) return;
		newNotification.clearNotificationTimeOut = window.setTimeout(() => {
			newNotification.toLeave = true;
			setTimeout(() => {
				this.closeNotificationByUniqueId(newNotification.uniqueId!);
			}, this._leaveTimer);
		}, newNotification.timerMS);
	}

	public setFunctionOnMessage(newFunction: Function): void {
		this.notificationLine.at(-1).functionOnMessage = newFunction;
	}

	public closeNotification(index: number): void {
		this.notificationLine[index].toLeave = true;
		setTimeout(() => {
			this.notificationLine.splice(index, 1);
			this.onScreenNotificationLine.splice(index, 1);
		}, this._leaveTimer);
	}

	public closeNotificationByUniqueId(uniqueId: string): void {
		const index = this.notificationLine.findIndex((notification) => notification.uniqueId === uniqueId);
		if (index === -1) return;
		this.closeNotification(index);
	}

	public async setPushNotificationMessage(notificationMessage: string, options?: notificationOptionsInterface): Promise<void> {
		if (Notification.permission !== 'granted') {
			const permission = await Notification.requestPermission();
			if (permission !== 'granted') return;
		}

		const findNotification = this.notificationLine.find(
			(notification) => notification.uniqueId !== undefined && notification.uniqueId === options?.uniqueId
		);
		if (notificationMessage === '' || (options?.uniqueId && findNotification)) return;

		const newNotification: notificationInterface = {
			notificationMessage: notificationMessage,
			functionOnMessage: undefined,
			clearNotificationTimeOut: undefined,
			toLeave: false,
			timerMS: 10_000,
			uniqueId: options?.uniqueId ?? Math.random().toString(36).slice(2),
		};

		this.notificationLine.push(newNotification);
		const notification = new Notification(notificationMessage, { requireInteraction: true, data: { url: options?.url } });
		notification.addEventListener('click', (event) => {
			if (options?.url) window.open(options.url, '_blank');
		});
		notification.addEventListener('close', (event) => {
			this.closeNotificationByUniqueId(newNotification.uniqueId!);
			newNotification.clearNotificationTimeOut && clearTimeout(newNotification.clearNotificationTimeOut);
			notification.close();
		});

		// Windows não notifica o browser de volta quando você arrasta a notificação pro lado,
		// então o timeout é necessário pra limpar a notificação mesmo que o usuário não feche ela
		newNotification.clearNotificationTimeOut = window.setTimeout(() => {
			newNotification.toLeave = true;
			setTimeout(() => {
				this.closeNotificationByUniqueId(newNotification.uniqueId!);
				notification.close();
			}, this._leaveTimer);
		}, newNotification.timerMS);
	}
}
